import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function Description() {
    return (
        <div className="skolkovo-kids__description">
            <div className="skolkovo-kids__description-inner">
                <div className="skolkovo-kids__description-title">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={800}
                    >
                        Описание проекта
                    </ScrollAnimation>
                </div>
                <div>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={800}
                    >
                        <div className="skolkovo-kids__description-text skolkovo-kids__description-text--margin">
                            Экосистема &laquo;Сколково&raquo;&nbsp;&mdash; это не&nbsp;только про
                            возможности и&nbsp;меры поддержки для стартапов и&nbsp;технологического
                            бизнеса. Это также различные образовательные проекты и&nbsp;программы
                            для детей и&nbsp;подростков. Конкурсы, летние смены, технологические
                            и&nbsp;бизнес-проекты, лекции и&nbsp;мастер-классы о&nbsp;науке
                            и&nbsp;технологиях&nbsp;&mdash; <br />
                            все это доступно ребятам в&nbsp;возрасте
                            от&nbsp;7&nbsp;до&nbsp;17&nbsp;лет. Ценности и&nbsp;мероприятия проекта
                            &laquo;Дети в&nbsp;Сколково&raquo; транслируются через различные каналы,
                            в&nbsp;том числе сообщество во&nbsp;&laquo;ВКонтакте&raquo;.
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__description-text">
                            Продвижением детского направления Технопарка &laquo;Сколково&raquo; наше
                            агентство занимается уже не&nbsp;первый год. Но&nbsp;остановиться хотим
                            на&nbsp;сообществе во&nbsp;&laquo;ВКонтакте&raquo;, которое стартовало
                            в&nbsp;начале марта 2022. В&nbsp;данном проекте команда агентства
                            &laquo;Вебпрактик&raquo; работает в&nbsp;тесном партнерстве
                            с&nbsp;коллегами из&nbsp;Skolkovo Kids и&nbsp;за&nbsp;9&nbsp;месяцев
                            смогли создать с&nbsp;нуля сообщество, наполнить его.
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    );
}

export default Description;
